module.exports = __webpack_public_path__ + "static/img/cart7.a64166a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cart7.png
// module id = TNpP
// module chunks = 2